import { IGetRequestLimitResponse } from './../../../interfaces/IRequestLimitArgs';
import config from '../../../_config/global';
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  IUpdateSingleArgs,
  IResetRequestLimit,
  IGetRequestLimit
} from '../../../interfaces';
import { goFetch } from '../../../utilities/goFetch';
import { ExportToCsv } from 'export-to-csv';
import {
  ICreateUserArgs,
  ICreateUserResponse,
  IUpdateSingleUserResponse
} from '../../../interfaces/IUserResponse';

interface apiResponse {
  data: Object;
  message: string;
  success: boolean;
}

class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    const users = (await goFetch(config.endpoints.users.getByPage)
      .withQueryParameters({
        search: search ?? '',
        pageSize: config.pageSize,
        pageNumber: pageNo || 1
      })
      .get()) as any;
    const { paginatedResults, totalCount } = users?.data[0] || {};
    const itemCount = totalCount?.[0]?.count || 0;
    return {
      pageNo: pageNo,
      pageSize: config.pageSize,
      pageCount: Math.ceil(itemCount / config.pageSize),
      data: paginatedResults,
      itemCount
    };
  }

  async getSingle({ key }: IGetSingleArgs) {
    const user = (await goFetch(`${config.endpoints.users.getSingle}`)
      .withQueryParameters({ id: key })
      .get()) as unknown as apiResponse;
    return user.data;
  }

  async create(args: ICreateUserArgs): Promise<ICreateUserResponse> {
    return (await goFetch(`${config.endpoints.users.add}`)
      .withBody(args)
      .post()) as unknown as ICreateUserResponse;
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {
    (await goFetch(`${config.endpoints.users.update}`)
      .withBody({
        _id: key,
        ...rest
      })
      .put()) as unknown as IUpdateSingleUserResponse;
  }

  async delete(key: IDeleteSingleArgs) {
    await goFetch(`${config.endpoints.users.delete}`)
      .withBody({ _id: key })
      .delete();
  }

  async getAwayzUserRequestLimit(
    args: IGetRequestLimit
  ): Promise<IGetRequestLimitResponse[]> {
    const userRequestLimit = (await goFetch(
      `${config.endpoints.users.getAwayzUserRequestLimit}`
    )
      .withQueryParameters(args)
      .get()) as unknown as apiResponse;

    return userRequestLimit.data as IGetRequestLimitResponse[];
  }

  async getBiltUserRequestLimit(
    args: IGetRequestLimit
  ): Promise<IGetRequestLimitResponse> {
    const userRequestLimit = (await goFetch(
      `${config.endpoints.users.getBiltRequestLimit}`
    )
      .withQueryParameters(args)
      .get()) as unknown as apiResponse;

    return userRequestLimit.data as IGetRequestLimitResponse;
  }

  async resetUserRequestLimit({ key, env }: IResetRequestLimit) {
    await goFetch(`${config.endpoints.users.resetRequestLimit}`)
      .withBody({
        userId: key,
        env: env
      })
      .put();
  }

  async export() {
    var users = (await goFetch(config.endpoints.users.getByPage)
      .withQueryParameters({
        search: '',
        pageSize: 1,
        pageNumber: 1
      })
      .get()) as any;
    var { paginatedResults, totalCount } = users?.data[0] || {};
    var itemCount = totalCount?.[0]?.count || 0;
    users = (await goFetch(config.endpoints.users.getByPage)
      .withQueryParameters({
        search: '',
        pageSize: itemCount,
        pageNumber: 1
      })
      .get()) as any;
    var { paginatedResults, totalCount } = users?.data[0] || {};

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(paginatedResults);
  }
}

export default new Service();
